import * as React from "react";
import { useAsyncValue } from "react-router-dom";
import { IAdvertisementAnalyticsLoaderData } from "../loader";
import CustomChart from "@/components/custom-chart";
import {
  dateFormatterForPeriod,
  getAggregationPeriodForDates,
} from "@/api/analytics";

export interface IImpressionChartProps {}

export default function ImpressionChart(props: IImpressionChartProps) {
  const { data, period } = useAsyncValue() as Awaited<
    IAdvertisementAnalyticsLoaderData["analytics"]
  >;
  return (
    <CustomChart
      data={data}
      config={{
        impressions: {
          label: "Impressions",
          color: "hsl(var(--chart-1))",
        },
        // interactions: {
        //   label: "Interactions",
        //   color: "hsl(var(--chart-2))",
        // },
      }}
      xAxis="hour"
      formatter={
        dateFormatterForPeriod[getAggregationPeriodForDates(...period)]
      }
      areas={{
        impressions: {
          type: "monotone",
        },
        // interactions: {
        //   type: "monotone",
        //   fill: "url(#fillDesktop)",
        //   stroke: "var(--color-interactions)",
        //   stackId: "b",
        // },
      }}
    />
  );
}
